import './basic_text_input.less';

import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import withFocusOnMount from './with_focus_on_mount.jsx';

const Input = withFocusOnMount('input');

const TextInput = ({ dark, tellRef, onEnterKeyUp, onEscKeyUp, className, hideCharacters, ...remainingProps})=>(
  <Input 
    type={hideCharacters ? 'password':'text' }
    onKeyUp={(e)=> {
      if (e.keyCode === 13 && onEnterKeyUp) {
        onEnterKeyUp(e);
      } else if (e.keyCode === 27 && onEscKeyUp) {
        onEscKeyUp(e);
      }
    }}
    onRefMount={tellRef}
    {...remainingProps} 
    className={classNames('basic-text-input', { dark:dark }, className)} />
);

TextInput.propTypes = {
  tellRef: PropTypes.func,
  onEnterKeyUp: PropTypes.func,
  hideCharacters: PropTypes.bool
};
TextInput.defaultProps = { 
  tellRef: noop,
  onEnterKeyUp: noop
};

export default TextInput;
